export interface Category {
  id: string;
  name: string;
  shortName: string;
  description: string;
  intro: string;
  tags: string[];
  icon: string;
}

export const categories: Category[] = [
  {
    id: "entertainment",
    name: "娱乐新闻",
    shortName: "娱乐",
    description: "影视、音乐、综艺一线动态，剧集与行业的深度观察。",
    intro:
      "追踪剧集、音乐与综艺的最新进度，也记录镜头之外的行业变化。这里有开机与收官，也有票房与排片，还有那些不太上热搜但值得一读的幕后故事。",
    tags: ["影视", "音乐", "综艺", "时尚", "行业", "人物"],
    icon: "ri-film-line",
  },
  {
    id: "gossip",
    name: "明星绯闻",
    shortName: "绯闻",
    description: "明星情感、片场动态与私下瞬间，理性围观，不传谣。",
    intro:
      "明星的情感动向、片场花絮与生活片段。我们只呈现已公开的信息与多方信源，对未经核实的说法保持标注，也提醒每一位读者：吃瓜需理性。",
    tags: ["情感", "片场", "人物", "时尚"],
    icon: "ri-heart-3-line",
  },
  {
    id: "society",
    name: "社会热点",
    shortName: "热点",
    description: "与娱乐产业相关的社会事件、消费维权与行业规则。",
    intro:
      "演出票务、版权争议、应援集资、群演生存……娱乐产业的外围同样值得关注。这一栏目关注规则如何形成，也关注规则之下具体的人。",
    tags: ["行业", "人物"],
    icon: "ri-fire-line",
  },
];

export const allTags: string[] = ["影视", "音乐", "综艺", "情感", "片场", "时尚", "行业", "人物"];